import React from "react";
// import "./1099Masterfile.css";
import "../../GlobalCss/SPF/1099Masterfile.css";
import { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { DeleteOutlined, UploadOutlined, ReloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Layout, Modal, Select } from "antd";
import { BaseUrl, JsonConfig, FormConfig, UserName } from "../../Repository/BaseRepository";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import { ErrorMessage, routes, SuccessMessage } from "../../Utils/Utils";
import { downloadMSXL, getPayrollData } from "../../Repository/TenNinetyNineRepository";
import MasterfileTable from "../../Components/1099Table/1099MasterfileTable";
import Cookies from "js-cookie";
const { Header, Content } = Layout;
const TenNinetyNineMasterfile = () => {
    const tenantName = Cookies.get("tenant_name");
    const [hrSourceFile, setHrSourceFile] = useState([]);
    const [spin, setSpin] = useState(false)
    const [hrUploader, setHrUploader] = useState("");
    const [tableLoader, setTableLoader] = useState(false)
    const [griddata, setGriddata] = useState([])
    const [csvLoader, setCsvLoader] = useState(false)
    const [weekendDates, setWeekendDates] = useState([])
    
    const [selectedValidatedRows, setSelectedValidatedRows] = useState([]);

    const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
      setSelectedValidatedRows(newSelectedRows);
      console.log("Selected Validated Rows:", newSelectedRows);
    };
    const clearSelectedRows = () => {
        setSelectedValidatedRows([]); // This unchecks all selected checkboxes
      };
    
    useEffect(() => {
        callAccoutsCube();
    }, [])
    const callAccoutsCube = async () => {
        try {
            setTableLoader(true)
            const res = await getPayrollData();
            if (res !== null && res.length > 0) {
                if (res[0] !== null && res[0] !== null) {
                    setGriddata(res[0])
                    setWeekendDates(res[1])
                }
            }
            if(res[0].length === 0){
                setGriddata([])
                setWeekendDates([])
            }
            setTableLoader(false)
        }
        catch {
            ErrorMessage("Cannot able to get data, please try again")
        }
    }
    const downloadMSfile = async (prop) => {
        try {
            setCsvLoader(true)
            const resp = await downloadMSXL(prop, griddata, weekendDates,selectedValidatedRows,clearSelectedRows)
            if (resp === "downloaded") {
                SuccessMessage("Downloaded successfully !!")
            }
            setCsvLoader(false)
        }
        catch {
            ErrorMessage("Cannot able to download, please try again")
            setCsvLoader(false)
        }
    }
    useEffect(() => {
        setSelectedValidatedRows([]); // Clear selection on data change
      }, [griddata]);
      
    return (<>
        <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
            <SideNavBar />
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <Header className="preview-header-class"><Navbar /></Header>
                <Content style={{ overflow: 'auto', height: "100%", marginLeft: 20 }}>
                    <div className="otherpage-buttons">
                        {/* <Link to="/payrollhoursaudit"><Button className="page-button">Payroll Hours Audit</Button></Link>
                                <Link to="/finalmasteraudit"><Button className="page-button">Final Master Audit</Button></Link> */}

                        <Link to={`/${tenantName}/1099crawl`}><Button className="page-button">Audit/Review</Button></Link>
                        <Link to={`/${tenantName}/1099`}> <Button className="page-button">Input file upload</Button></Link>
                        <Button className="currentpage-button">Masterfile</Button>

                        {/* <Link to="/activitylog"><Button className="page-button">Activity Log</Button></Link> */}
                    </div>
                    <div className="ten99ms-row1">
                        <div style={{ display: "flex", alignItems: "center", paddingRight: 10 }}>
                            {/* <Button onClick={downloadMSfile} className="dwld-invoice">Download Invoice</Button> */}
                            <Select
                                onSelect={downloadMSfile}
                                className="ts-drowpdowns"
                                loading={csvLoader}
                                placeholder={
                                    <span
                                        className="placeholder-span"
                                        // style={{ color: "rgba(59, 82, 223, 1)" }}
                                    >
                                        Download as
                                    </span>
                                }
                                style={{ width: 210, marginLeft: 15 }}
                                options={[
                                    {
                                        value: "one",
                                        label:
                                            "Download Invoice",
                                    },
                                    {
                                        value: "two",
                                        label:
                                            "VIJ AX Template",
                                    },
                                    {
                                        value: "three",
                                        label: "Accruals Template",
                                    },
                                    {
                                        value: "four",
                                        label: "OT-PO Template",
                                    },
                                    
                                ]}
                            />
                        </div>
                    </div>
                    <div style={{ paddingRight: 10 }}>
                        <MasterfileTable tableLoader={tableLoader} griddata={griddata} setGriddata={setGriddata} setTableLoader={setTableLoader} 
                        weekendDates={weekendDates} setWeekendDates={setWeekendDates} onSelectChange={onSelectChange}    // <-- pass handler for row selection
                        selectedValidatedRows={selectedValidatedRows}/>
                    </div>
                </Content>
            </Layout>
        </Layout>
    </>)
}
export default TenNinetyNineMasterfile;